import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';

const widgetStyle = `
#botssy-widget-btn{position:fixed!important;bottom:20px!important;right:20px!important;z-index:100000!important;width:60px!important;height:60px!important;min-width:60px!important;min-height:60px!important;border-radius:50%!important;border:none!important;background:linear-gradient(135deg,#165dfc,#3b82f6)!important;color:#fff!important;cursor:pointer!important;box-shadow:0 4px 20px rgba(22,93,252,.4)!important;display:flex!important;align-items:center!important;justify-content:center!important;transition:transform .3s,box-shadow .3s!important;box-sizing:border-box!important;padding:0!important;margin:0!important;line-height:1!important;font-size:0!important;overflow:hidden!important}
#botssy-widget-btn:hover{transform:scale(1.1)!important;box-shadow:0 6px 28px rgba(22,93,252,.5)!important}
#botssy-widget-btn svg{width:28px!important;height:28px!important;fill:none!important;stroke:currentColor!important;stroke-width:2!important}
#botssy-widget-btn.open .botssy-icon-chat{display:none!important}#botssy-widget-btn.open .botssy-icon-close{display:block!important}#botssy-widget-btn:not(.open) .botssy-icon-chat{display:block!important}#botssy-widget-btn:not(.open) .botssy-icon-close{display:none!important}
#botssy-widget-frame{position:fixed!important;bottom:92px!important;right:20px!important;z-index:99999!important;width:400px!important;height:600px!important;max-height:calc(100vh - 120px)!important;border:none!important;border-radius:16px!important;box-shadow:0 8px 40px rgba(0,0,0,.18)!important;opacity:0;transform:translateY(20px) scale(.95);transition:opacity .3s,transform .3s!important;pointer-events:none;background:#fff!important}
#botssy-widget-frame.visible{opacity:1!important;transform:translateY(0) scale(1)!important;pointer-events:auto!important}
#botssy-widget-topbar{display:none!important}
@media(max-width:640px){#botssy-widget-frame.visible{top:44px!important;left:0!important;right:0!important;bottom:0!important;width:100%!important;height:calc(100% - 44px)!important;max-height:none!important;border-radius:0!important;box-shadow:none!important}#botssy-widget-btn.open{display:none!important}#botssy-widget-topbar{position:fixed!important;top:0!important;left:0!important;right:0!important;height:44px!important;z-index:100001!important;background:#165dfc!important;align-items:center!important;justify-content:space-between!important;padding:0 12px!important}#botssy-widget-topbar.visible{display:flex!important}#botssy-widget-topbar span{color:#fff!important;font:600 15px sans-serif!important}#botssy-widget-topbar button{background:none!important;border:none!important;color:#fff!important;cursor:pointer!important;width:32px!important;height:32px!important;display:flex!important;align-items:center!important;justify-content:center!important;border-radius:50%!important}}
`;

export default function BotssyWidget() {
  const [host, setHost] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const existingHost = document.getElementById('botssy-widget-root');
    const widgetHost = existingHost || document.createElement('div');
    if (!existingHost) {
      widgetHost.id = 'botssy-widget-root';
      document.body.appendChild(widgetHost);
    }
    setHost(widgetHost);
    // React desmonta el contenido del portal. El contenedor se conserva para
    // que el reconciliador no intente eliminar un nodo cuyo padre ya quitamos
    // manualmente (causa el error NotFoundError/removeChild en el wizard).
  }, []);

  if (!host) return null;

  return createPortal(
    <>
      <style>{widgetStyle}</style>
      <button
        id="botssy-widget-btn"
        type="button"
        aria-label={open ? 'Cerrar chat de soporte' : 'Abrir chat de soporte'}
        className={open ? 'open' : ''}
        onClick={() => setOpen((current) => !current)}
      >
        <svg className="botssy-icon-chat" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
        <svg className="botssy-icon-close" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <iframe
        id="botssy-widget-frame"
        className={open ? 'visible' : ''}
        src="https://webchat.botssy.com/29"
        title="Botssy Chat"
        allow="microphone; camera"
      />
      <div id="botssy-widget-topbar" className={open ? 'visible' : ''}>
        <span>Botssy Chat</span>
        <button type="button" aria-label="Cerrar" onClick={() => setOpen(false)}>
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </>,
    host,
  );
}
